import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Managed, { useManaged } from "../common/components/Managed";
import api from "../common/lib/api";
import moment from "moment";
import { Intent } from "@blueprintjs/core";
import AsyncButton from "../common/components/AsyncButton";
import { TrackingDetails } from "./SaleOrdersPage";

export default function Page() {
  const { saleOrderId } = useParams();
  const [state, setState, setError] = useManaged();

  async function load(saleOrderId, setState, setError) {
    try {
      const { data } = await api.get("/sale-orders/item/" + saleOrderId);
      setState(data.data);
    } catch (e) {
      setError(e);
    }
  }

  async function printPackingSlip() {
    try {
      const { data } = await api.get(
        "/sale-orders/item/" + saleOrderId + "/packing-slip",
        { responseType: "blob" }
      );
      const fileURL = URL.createObjectURL(data);
      window.open(fileURL);
    } catch (e) {
      alert(e);
    }
  }

  async function printInvoice() {
    try {
      const { data } = await api.get(
        "/sale-orders/item/" + saleOrderId + "/invoice",
        { responseType: "blob" }
      );
      const fileURL = URL.createObjectURL(data);
      window.open(fileURL);
    } catch (e) {
      alert(e);
    }
  }

  useEffect(() => {
    load(saleOrderId, setState, setError);
  }, [saleOrderId, setError, setState]);

  const { data } = state;

  const isFinished = data && data.isFinished;
  const isInvoiced = data && data.isInvoiced;
  const isOpen = data && data.status === "Open";
  const paymentIsDue = (data && data.terms && data.terms.paymentIsDue) || "";

  const isCod = paymentIsDue.toLowerCase() === "cashondelivery";
  const isPrepaid = paymentIsDue.toLowerCase() === "prepaid";

  return (
    <>
      <h1>Sale Order</h1>
      <Managed state={state}>
        {data && (
          <>
            <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-striped">
              <tbody>
                <tr>
                  <th>Customer</th>
                  <td>
                    <a href={`/companies/${data.companyId}`}>
                      {data.companyName}
                    </a>
                  </td>
                  <th>Date</th>
                  <td>{moment(data.createdAt).format("YYYY-MM-DD")}</td>
                </tr>
                <tr>
                  <th>Order No</th>
                  <td>{data.saleOrderDisplayId}</td>
                  <th>Customer Order No</th>
                  <td>{data.customerOrderNo || "-"}</td>
                </tr>
                <tr>
                  <th>Delivery Method</th>
                  <td>{data.deliveryMethod || "-"}</td>
                  <th>Delivery Address</th>
                  <td style={{ whiteSpace: "pre-wrap" }}>
                    {data.shipToAddress || "-"}
                  </td>
                </tr>
                <tr>
                  <th>Delivery Comments</th>
                  <td colSpan="3">{data.deliveryComments || "-"}</td>
                </tr>
                <tr>
                  <th>Freignt Cost</th>
                  <td>{data.deliveryCost || "-"}</td>
                  <th>Tracking Details</th>
                  <td>
                    <TrackingDetails value={data.shippingTrackingDetails} />
                  </td>
                </tr>
                {isCod && (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#ffcccc",
                        textAlign: "center",
                        border: "1px solid red",
                      }}
                    >
                      Cash On Delivery Order
                    </td>
                  </tr>
                )}
                {isPrepaid && (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#ffcccc",
                        textAlign: "center",
                        border: "1px solid red",
                      }}
                    >
                      Prepaid Order
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <h2>Items</h2>
            <table className="bp3-html-table bp3-html-table-striped bp3-html-table-bordered">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Description</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {data.lines.map((line, index) => (
                  <tr key={line.itemId + index}>
                    <td>{line.itemId}</td>
                    <td style={{ whiteSpace: "pre-wrap" }}>
                      {line.description}
                      {line.deviceIds && (
                        <p>
                          <small>
                            {line.deviceIds
                              .map((x) => (typeof x === "number" ? "#" + x : x))
                              .join(", ")}
                          </small>
                        </p>
                      )}
                    </td>
                    <td>{line.quantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {Boolean(isInvoiced) && (
              <AsyncButton intent={Intent.PRIMARY} onClick={printInvoice}>
                Print Invoice
              </AsyncButton>
            )}

            {Boolean(isFinished) && (
              <AsyncButton intent={Intent.PRIMARY} onClick={printPackingSlip}>
                Print Packing Slip
              </AsyncButton>
            )}

            {isOpen && (
              <Link
                className={"bp3-button bp3-intent-primary"}
                to={`/sale-order/${saleOrderId}/pack`}
              >
                {isFinished ? "Re Pack Order" : "Pack Order"}
              </Link>
            )}

            {/* <pre>{JSON.stringify(data, null, 2)}</pre>
            <pre>{data.raw}</pre> */}
          </>
        )}
      </Managed>
    </>
  );
}
